export default __webpack_public_path__ + "static/media/VKOW_11_mos_JTAN.e631946b.wav";